export default {"src":"/_next/static/media/call-gradient.739ad403.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};